"use strict";
// @ts-ignore
try {
    self['workbox:routing:7.0.0'] && _();
}
catch (e) { }
